import { fullscreenLoader } from '@core/components/Loader/Page/PageLoader';
import { useAuth } from '@waitroom/auth';
import { Role } from '@waitroom/models';
import { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

export type AuthRedirectProps = {
  authenticated: boolean;
  role?: Role;
  redirectUrl: string;
  children: ReactNode;
  redirectUrlMissingRole?: string;
};

const AuthRedirect = ({
  authenticated,
  role,
  redirectUrl,
  redirectUrlMissingRole,
  children,
}: AuthRedirectProps): ReactElement | null => {
  const { state, isLoading } = useAuth();
  const shouldRedirect =
    // not loading
    !isLoading &&
    // has correct authenticated state
    ((authenticated && state.isAuthenticated) || (!authenticated && !state.isAuthenticated));

  const hasRole = !role || (!!role && !!state.roles?.[role]);

  if (isLoading) return fullscreenLoader;

  if (shouldRedirect && !hasRole && redirectUrlMissingRole)
    return <Navigate to={redirectUrlMissingRole} />;

  return shouldRedirect && hasRole ? <Navigate to={redirectUrl} /> : <>{children}</>;
};
export default AuthRedirect;
